import React from 'react'
import PropTypes from 'prop-types'

function PassSteps(props) {

    const { page } = props
    return (
        <div className='container'>
        <div className="row justify-content-center"><div className="col-md-10"> 
        <div className="stpes-Design">
            <div className={page == 'home' ? 'bullet active' : 'bullet'}>
                <div className="box">
                    <span>1</span>
                </div>
            </div>
            <div className={page == 'payment' ? 'bullet active' : 'bullet'}>
                <div className="box"><span>2</span> </div>
            </div>
            <div className={page == 'confirmation' ? 'bullet active' : 'bullet'}>
                <div className="box"><span>3</span> </div>
            </div>
        </div>
        </div>
        </div>
        </div>

    )
}
PassSteps.propTypes = {
    page: PropTypes.string,
    paymentStatus: PropTypes.bool
}

PassSteps.defaulProps = {
    page: undefined,
    paymentStatus: false
}
export default PassSteps
